// extracted by mini-css-extract-plugin
export default {"news-list":"styles_news-list__dA4BH"};